import React, {Component} from 'react';
import Routes from "./Routes";
import { API } from "aws-amplify";
import './resources/overrides.css';
import ReactGA from 'react-ga';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { // load Tidio into our app

    ReactGA.initialize('UA-132411094-1'); // initialize our Google Analytics tracking script
    ReactGA.pageview(window.location.pathname); // add "+ window.location.search" to include query parameters
    
    API.get("api", "/details" + window.location.search)
    .then(response => {
      if(response) { // If we got back a response set up the customer details
        document.tidioIdentify = response; // set the customer details so we can identify them
        this.loadLiveChat(); // load the livechat
      }
    })
    .catch(error => {
      console.log(error.response); // Otherwise log the error, if any
      this.loadLiveChat(); // load the livechat anyway
    });
  }

  componentDidUpdate() { // Update GA when our route updates
    ReactGA.pageview(window.location.pathname); // add "+ window.location.search" to include query parameters
  }

  loadLiveChat() {
    const script = document.createElement("script");
    script.src = "//code.tidio.co/hybe8rwvyn0pr9pd233dlx6rm1snht7l.js";
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    return (
      <Routes />
    );
  }

  valueUpdater(field) {
    return (value) => this.setState({[field]: value});
  }
}

export default App;
